export class CommonUtils {
  static test = () => {
    console.log("testing");
  };
}
